<template>
  <v-row justify="end">
    <v-dialog v-model="dialog" persistent max-width="1050px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="primary" small fab dark v-bind="attrs" v-on="on">
          <v-icon>mdi-plus</v-icon>
        </v-btn>

        <span class="text" style="padding-top: 10px; padding-left: 15px"> Nuevo tipo egreso </span>
      </template>
      <v-form ref="form" v-model="validForm" lazy-validation>
        <v-card>
          <div class="padding-card">
            <p class="title-modal">Registrar Tipo Egreso</p>
            <RegisterSpendType @savenewtype="save"/>
          </div>
          <v-card-actions>
            <!-- <v-btn :disabled="!validForm" @click="validate" depressed color="#00aff2" dark> Guardar usuario </v-btn> -->
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialog = false"> Cerrar </v-btn>
          
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-row>
</template>

<script>

import RegisterSpendType from './RegisterSpendType.vue';
import adminSuppliersService from '@/services/admin/supplierPayments';

export default {
  name: 'ModalUser',
  components: {
    RegisterSpendType,
  },
  data: () => ({
    validForm: true,
    dialog: false,
    readyToSave: false,
  }),

  methods: {
    close() {
      this.dialog = false;
      this.$refs.formSpendType.reset();
    },
    save(data) {        
      adminSuppliersService
        .createSpendType(data)
        .then(() => {
        
          this.$swal('Tipo de Egreso', 'Registro exitoso', 'success');
          this.dialog = false;
          this.$emit('getPaymentTypes');
        })
        .catch((error) => {
          if (error.response && error.response.status === 400) {
            this.$swal('Error al registrar el Tipo de Egreso', error.response.data.message, 'warning');
          } else if (error.response && error.response.status === 409) {
            this.$swal('Error. El tipo de egreso puede estar duplicado', error.response.data.message, 'warning');                 
          } else {
            this.$swal('Error al registrar el Tipo de Egreso', error.response.data.message, 'warning');
          }
          this.dialog = false;
      });     
    },    
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/style.scss';
</style>